import PropTypes from 'prop-types'
import React from 'react'
import { Avatar, Card, CardHeader, CardContent, IconButton, Menu, MenuItem, Typography } from '@material-ui/core'
import { ExpandLess, ExpandMore, MoreVert } from '@material-ui/icons'
import { GeneratedIcon, Icon } from '~/components/Icon'

class DashboardGroupCard extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      showAll: false,
      menuAnchor: null
    }
  }

  render () {
    const palette = this.context.muiTheme.palette
    const { language } = this.context
    const { width, group, onClick, onEditClick, forceUpdate } = this.props
    const { showAll, menuAnchor } = this.state

    return (
      <Card
        key={group.ID}
        className='card clickable'
        style={{
          width,
          marginLeft: '10px',
          marginRight: '10px',
          marginTop: '20px',
          marginBottom: '20px',
          padding: '0px',
          backgroundColor: (this.context.location.query.gsid === group.ID)
            ? palette.borderColor
            : palette.canvasColor
        }}
      >
        <CardHeader
          title={group.GroupName}
          subheader={<div>
            <div>{group.GroupDescription.substr(0, 200)}{group.GroupDescription.length > 200 && '...'}</div>
          </div>}
          avatar={(group.IconName)
            ? <Icon icon={group.IconName} size={40} />
            : <GeneratedIcon
              text={group.GroupName}
              randomizer={group.ID}
            />}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onClick(group.ID)
          }}
          style={{ paddingTop: '8px', paddingLeft: '8px', width: '100%' }}
          titleTypographyProps={{
            style: {
              fontSize: '18px',
              lineHeight: '22px',
              fontWeight: '600',
              width: '100%'
            }
          }}
          action={
            <IconButton
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                this.setState({
                  menuAnchor: e.currentTarget
                })
              }}
            >
              <MoreVert />
            </IconButton>
          }
        />
        <Menu
          className='menu'
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={() => { this.setState({ menuAnchor: null }) }}
          getContentAnchorEl={null}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        >
          <MenuItem
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              this.setState({ menuAnchor: null })
              onClick(group.ID)
            }}
          >{language.translate('application.viewDashboard')}</MenuItem>
          <MenuItem
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              this.setState({ menuAnchor: null })
              onEditClick(group.ID)
            }}
          >{language.translate('application.editDashboard')}</MenuItem>
        </Menu>
        <CardContent
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onClick(group.ID)
          }}
          style={{
            paddingLeft: '15px',
            paddingRight: '15px',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap'
          }}
        >
          {(!group.TemplateList || !group.TemplateList.length)
            ? language.translate('application.noTemplates')
            : group.TemplateList.map((template, index) => (
              (index < 7 || showAll)
                ? <div
                  key={index}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '65px'
                  }}
                >
                  {(template.IconName)
                    ? <Icon icon={template.IconName} size={40} />
                    : <GeneratedIcon
                      text={template.Title}
                      randomizer={template.ID}
                    />}
                  <Typography style={{
                    width: '65px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}>{template.Title}</Typography>
                </div>
                : null
            ))}
          {(group.TemplateList && group.TemplateList.length > 7)
            ? <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '65px'
              }}
            >
              <Avatar>
                {(!showAll)
                  ? <ExpandMore
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      this.setState({ showAll: true }, () => forceUpdate())
                    }}
                  />
                  : <ExpandLess
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      this.setState({ showAll: false }, () => forceUpdate())
                    }}
                  />}
              </Avatar>
              <Typography>
                {(!showAll) ? language.translate('application.showAll') : language.translate('application.less')}
              </Typography>
            </div>
            : null}
        </CardContent>
      </Card>
    )
  }
}

DashboardGroupCard.propTypes = {
  group: PropTypes.object.isRequired,
  get: PropTypes.func,
  width: PropTypes.string.isRequired,
  forceUpdate: PropTypes.func,
  onEditClick: PropTypes.func,
  onClick: PropTypes.func
}

DashboardGroupCard.contextTypes = {
  muiTheme: PropTypes.object,
  location: PropTypes.object,
  language: PropTypes.object
}

export default DashboardGroupCard
